import Processo from '@/assets/ts/interfaces/Processo';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';

import VagaCard from '@/components/recrutamento/VagaCard/VagaCard.vue';
import ProcessoController from '@/assets/ts/controller/ProcessoController';
import TkToolbar from '@/../bower_components/teknisavuecomponents/components/grids/TkToolbar.vue';
import ToolbarAction from 'bower_components/teknisavuecomponents/assets/interfaces/ToolbarAction';
import ProcessoPopup from '@/components/recrutamento/ProcessoPopup/ProcessoPopup.vue';

@Component({
  name: 'RecrutamentoSelecao',
  components: {
    VagaCard,
    TkToolbar,
    ProcessoPopup,
  },
})
class RecrutamentoSelecao extends Vue {
  // #region [ PROPS ]
  // #endregion

  // #region [ STORE ]
  @Mutation('changeCurrentView')
  private changeCurrentView: (string) => void;
  // #endregion

  // #region [ EVENTS ]
  // #endregion

  // #region [ DATA ]
  private readonly viewTitle = 'Recrutamento e Seleção';

  private processos: Processo[] = [];

  private loading = false;

  private processoPopup = {
    show: false,
    row: null as Processo,
  };
  // #endregion

  // #region [ COMPUTED ]
  private get actions(): ToolbarAction[] {
    return [
      {
        name: 'reload',
        label: 'Atualizar',
        icon: 'mdi-refresh',
        onClick: this.reload,
      },
    ];
  }
  // #endregion

  // #region [ WATCHERS ]
  // #endregion

  // #region [ LIFECYCLE ]
  private created(): void {
    this.changeCurrentView(this.viewTitle);
    (window as any).recrutamentoSelecao = this;

    this.reload();
  }
  // #endregion

  // #region [ METHODS ]
  private async reload(): Promise<void> {
    this.loading = true;

    try {
      const processos = await ProcessoController.getProcessosGestor(false);
      this.processos = processos;
    } finally {
      this.loading = false;
    }
  }

  private vagaOnClick(vaga: Processo): void {
    this.processoPopup.show = true;
    this.processoPopup.row = vaga;
  }
  // #endregion
}

export default RecrutamentoSelecao;
